import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const whatsappButtonStyle = {
  position: "fixed",
  top: "38px", // <-- aqui mudou
  right: "20px",
  backgroundColor: "#25D366",
  color: "#fff",
  borderRadius: "50%",
  width: "20px",
  height: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "28px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  cursor: "pointer",
  zIndex: 1000,
};

const WhatsappButton = ({ phoneNumber, message }) => {
  const handleWhatsappClick = () => {
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <div
      style={whatsappButtonStyle}
      onClick={handleWhatsappClick}
      title="Fale conosco no WhatsApp"
    >
      <FaWhatsapp />
    </div>
  );
};

export default WhatsappButton;
